module.exports = __webpack_public_path__ + "static/media/ribbon_g_1.cc371876.svg";